import { validRoleCodes } from 'src/constants/constants';

const userRolesConfig = data => {
  let config = {
    applicant: false,
    corpClient: false,
    eyPro: false,
    eyAdmin: false,
    eyEngagementAdmin: false,
    corporateClientlineManager: false,
    restrictedCorpMember: false,
  };

  if (!data.userInfo || !data.userInfo.permissions) return config;

  data.userInfo.permissions.forEach(permission => {
    validRoleCodes.forEach(role => {
      if (role.roleKey === permission.roleKey) {
        config[role.roleType] = true;
      }
    });
  });

  return config;
};

export default userRolesConfig;
